import { Link } from 'react-router-dom';

const serviceLinks = [
  { name: 'Commercial Cleaning', path: '/services/commercial-cleaning' },
  { name: 'Janitorial Services', path: '/services/janitorial' },
  { name: 'Office Cleaning', path: '/services/office-cleaning' },
  { name: 'Floor Care & Maintenance', path: '/services/floor-care' },
  { name: 'Post-Construction Cleaning', path: '/services/post-construction' },
  { name: 'Specialized Cleaning', path: '/services/specialized' },
  { name: 'Professional Staffing', path: '/services/staffing' },
  { name: 'Valet Parking', path: '/services/valet' },
];

const quickLinks = [
  { name: 'Home', path: '/' },
  { name: 'About Us', path: '/about' },
  { name: 'Houston, TX', path: '/locations/houston' },
  { name: 'Contact Us', path: '/contact' },
];

export default function Footer() {
  return (
    <footer className="bg-[#03143A] text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-4 gap-10 mb-12">
          <div className="md:col-span-1">
            <img
              src="https://primefacilityservicesgroup.com/logo-prime-facility-white.png"
              alt="Prime Facility Services Group"
              className="h-12 w-auto mb-4"
            />
            <p className="text-white/65 text-sm leading-relaxed mb-6">
              Houston&apos;s premier facility management partner delivering professional cleaning, staffing, and valet services with a commitment to excellence.
            </p>
            <div className="flex items-center gap-3">
              <a href="https://www.facebook.com" target="_blank" rel="nofollow noreferrer" className="w-9 h-9 flex items-center justify-center bg-white/10 hover:bg-[#C70532] rounded-full transition-all duration-300 cursor-pointer">
                <i className="ri-facebook-fill text-sm" />
              </a>
              <a href="https://www.instagram.com" target="_blank" rel="nofollow noreferrer" className="w-9 h-9 flex items-center justify-center bg-white/10 hover:bg-[#C70532] rounded-full transition-all duration-300 cursor-pointer">
                <i className="ri-instagram-line text-sm" />
              </a>
              <a href="https://www.linkedin.com" target="_blank" rel="nofollow noreferrer" className="w-9 h-9 flex items-center justify-center bg-white/10 hover:bg-[#C70532] rounded-full transition-all duration-300 cursor-pointer">
                <i className="ri-linkedin-fill text-sm" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-bold text-sm uppercase tracking-widest text-white/50 mb-5">Quick Links</h3>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-white/70 hover:text-white text-sm transition-colors cursor-pointer">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-sm uppercase tracking-widest text-white/50 mb-5">Our Services</h3>
            <ul className="space-y-2.5">
              {serviceLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-white/70 hover:text-white text-sm transition-colors cursor-pointer">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-sm uppercase tracking-widest text-white/50 mb-5">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-[#C70532]" />
                </div>
                <span className="text-white/70 text-sm leading-relaxed">8303 Westglen Dr,<br />Houston, TX 77063</span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-fill text-[#C70532]" />
                </div>
                <a href="tel:+17133382553" className="text-white/70 hover:text-white text-sm transition-colors cursor-pointer">
                  (713) 338-2553
                </a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-[#C70532]" />
                </div>
                <a href="mailto:its@primefacilityservicesgroup.com" className="text-white/70 hover:text-white text-sm transition-colors cursor-pointer break-all">
                  its@primefacilityservicesgroup.com
                </a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-[#C70532]" />
                </div>
                <span className="text-white/70 text-sm">24/7 Emergency Services Available</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/45 text-sm">&copy; {new Date().getFullYear()} Prime Facility Services Group. All rights reserved.</p>
          <p className="text-white/45 text-xs">Licensed &bull; Insured &bull; Bonded &bull; Houston, TX</p>
        </div>
      </div>
    </footer>
  );
}
